import { ANDROID_REFERRER_KEYWORD } from '../config/context';
import { getAppContextFromLocalStorage } from './context';

/**
 * @param {string} className
 * @param {number} opacity
 */
export const setOpacity = (className, opacity) => {
	const ele = document.querySelector(`.${className}`);
	if (ele == null) return;
	ele.style.opacity = opacity;
};

/**
 * @param {string} className
 * @param {number} zindex
 */
const setZindex = (className, zindex) => {
	const ele = document.querySelector(`.${className}`);
	if (ele == null) return;
	ele.style.zIndex = zindex;
};

/**
 * @param {string | string[]} classNames
 * @param {number} zindex
 */
export const setZindexByClassNames = (classNames, zindex) => {
	if (typeof classNames === 'string') setZindex(classNames, zindex);
	else if (Array.isArray(classNames)) classNames.forEach((className) => setZindex(className, zindex));
};

/**
 * @param {string} className
 * @param {string} display
 * @param {string} priority
 * @returns
 */
export const setDisplay = (className, display, priority) => {
	const ele = document.querySelector(`.${className}`);
	if (ele == null) return;
	ele.style.setProperty('display', display, priority);
};

/**
 * When access by android twa app it will send a string of referrer Eg: android-app://com.orthographiq.staging.twa While browser will return an empty string
 * @returns is user using Android TWA APP
 */
export const detectAndroidUserByReferrer = () => {
	const localContext = getAppContextFromLocalStorage();
	const referrer = localContext.referrer;
	if (referrer.includes(ANDROID_REFERRER_KEYWORD)) return true;
	return false;
};

/**
 * Detects if the current environment is an iOS app WebView (not Safari or Chrome browser)
 * @returns {boolean} true if user is using iOS app, false otherwise
 */
export const detectIosApp = () => {
	try {
		const userAgent = navigator.userAgent || '';

		// Check for custom header or property that might be set by the iOS app
		if (window.isOrthographiqIosApp === true) {
			return true;
		}

		// Check if it's an iOS device
		const isIos = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
		if (!isIos) return false; // Not iOS device at all

		// Check for common browsers - return false if detected
		const isSafari = /Safari/.test(userAgent);
		const isChrome = /CriOS/.test(userAgent); // Chrome on iOS
		const isFirefox = /FxiOS/.test(userAgent); // Firefox on iOS
		const isEdge = /EdgiOS/.test(userAgent); // Edge on iOS

		// If it's a common browser, it's not our app
		if ((isSafari && !userAgent.includes('Mobile/')) || isChrome || isFirefox || isEdge) {
			return false;
		}

		// App-specific indicators
		const hasAppSpecificString = userAgent.includes('OrthographiqApp');
		const isWKWebView = isIos && userAgent.includes('AppleWebKit') && !userAgent.includes('Version/');
		const isStandaloneMode = window.navigator.standalone === true;

		// Custom property that might be injected by the app's JavaScript bridge
		const hasAppBridge = typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers !== 'undefined';

		return hasAppSpecificString || isWKWebView || hasAppBridge || isStandaloneMode;
	} catch (error) {
		console.error('Error detecting iOS app:', error);
		return false;
	}
};

/**
 * Get static image url from assets/images folder
 * @param {string} imageName
 * @returns {string} image url
 */
export const getImgUrl = (imageName) => {
	const images = require.context('@/assets/images', false);
	return images('./' + imageName);
};

/**
 * Subtract number of date from now
 * @param {number} days
 * @return {number} is unix timestamp format
 */
export const substractFromNow = (days) => {
	const now = new Date();
	return now.setDate(now.getDate() - days);
};

export const delay = (ms) => {
	return new Promise((resolve) => setTimeout(resolve, ms));
};
